"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdate = exports.usePageView = exports.useEvent = exports.useEngagement = exports.update = exports.setup = exports.pulseTracker = exports.pageView = exports.getDeployTag = exports.event = exports.engagement = exports.bufferedEvents = exports.bufferIfNecessary = void 0;
var _pulseSdk = _interopRequireDefault(require("@m10s/pulse-sdk"));
var _react = require("react");
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line import/no-mutable-exports
var pulseTracker;
var bufferedEvents = exports.bufferedEvents = [];
var warnedAboutEngagementTypeOnce = false;
var isServerside = function isServerside() {
  return typeof window === 'undefined';
};
var isBrowser = function isBrowser() {
  return !isServerside();
};
var stageMap = {
  production: 'pro',
  qa: 'pre',
  development: 'dev'
};
var getDeployTag = exports.getDeployTag = function getDeployTag(environment) {
  if (environment !== 'qa' && environment !== 'development') {
    return '';
  }
  var _window$location$host = window.location.hostname.split('.', 1),
    _window$location$host2 = _slicedToArray(_window$location$host, 1),
    host = _window$location$host2[0];
  host = host.split('-', 1);
  return "blocket-".concat(host, "-").concat(environment);
};

/**
 * Takes a function name on the Pulse tracker and either calls is it immediatley.
 *
 * @param func - The name of the function on the Pulse tracker instance that should be called.
 * @param parameters - A list of parameters that the `func` function should be called with.
 */
// eslint-disable-next-line prefer-spread
var callImmediately = function callImmediately(func, parameters) {
  return pulseTracker[func].apply(pulseTracker, parameters);
};
var sendBufferedEvents = function sendBufferedEvents() {
  bufferedEvents.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      func = _ref2[0],
      parameters = _ref2[1];
    return callImmediately(func, parameters);
  });
  // Clear the buffer, this syntax is hideous but it is the only way to clear the array without
  // repeated `.pop` calls or removing the const modifier on the instance.
  bufferedEvents.length = 0;
};
var setup = exports.setup = function setup(providerId, author, environment, applicationName, applicationVersion, blocketApiUrl, userId) {
  var createTracker = function createTracker(useEnricher) {
    var cookies = new _universalCookie["default"]();
    environment = environment in stageMap ? environment : 'production';
    var deployTag = getDeployTag(environment);
    var deployStage = stageMap[environment];
    var pulseDebugNameCookie = cookies.get('pulse_debug_name');
    var pulseDebugEnvCookie = cookies.get('pulse_debug_env');
    if (pulseDebugNameCookie) {
      deployTag = pulseDebugNameCookie;
    }
    if (pulseDebugEnvCookie) {
      deployStage = 'dev';
    }
    var config = {};
    var defaultValues = {
      deployStage: deployStage,
      provider: {
        author: author,
        productType: 'ResponsiveWeb',
        product: "".concat(applicationName, ":").concat(applicationVersion),
        component: applicationName,
        componentVersion: applicationVersion
      }
    };
    if (useEnricher) {
      config.configurationTag = 'blocket';
    }
    if (deployTag) {
      defaultValues.deployTag = deployTag;
    }

    /**
     * NOTE: It is very likely that this library will be called before the
     * Sourcepoint integration is setup, this consent request will not have any
     * effects in that case.
     */
    if (window._scc_ && window._scc_.getCachedOrDefaultConsentsForPulse) {
      config.consents = window._scc_.getCachedOrDefaultConsentsForPulse();
    } else if (window._tcf_ && window._tcf_.getCachedOrDefaultConsentsForPulse) {
      config.consents = window._tcf_.getCachedOrDefaultConsentsForPulse();
    }
    if (pulseTracker) {
      /**
       * Drain the old tracker.
       */
      sendBufferedEvents();
      pulseTracker.send();
    }
    if (window.__nativeJwe__) {
      config.nativeJwe = window.__nativeJwe__;
    }
    if (typeof window.pulseEventHandler === 'function') {
      config.altEventHandler = window.pulseEventHandler;
    }
    exports.pulseTracker = pulseTracker = new _pulseSdk["default"](providerId, config, defaultValues);
    window.blocketPulse = function (callback) {
      return callback && callback(pulseTracker);
    };
    sendBufferedEvents();
  };
  if (blocketApiUrl) {
    var url = "".concat(blocketApiUrl, "/beat-be/v1/config/web");
    url += userId ? "?id=".concat(userId) : '';

    /**
     * If setup is triggered several times in a row there is a slight chance that a previous request
     * that randomly took a longer time to respond will end up being the final result.
     */
    fetch(url).then(function (response) {
      return response.json();
    })
    // eslint-disable-next-line camelcase
    .then(function (data) {
      return (data === null || data === void 0 ? void 0 : data.use_enricher) || false;
    })["catch"](function () {
      return false;
    }).then(createTracker);
  } else {
    createTracker(false);
  }
};

/**
 * Takes a function name on the Pulse tracker and either calls is it immediatley or buffer it so it
 * gets called later when the Pulse tracker is setup.
 *
 * @param func - The name of the function on the Pulse tracker instance that should be called.
 * @param parameters - A list of parameters that the `func` function should be called with.
 */
var bufferIfNecessary = exports.bufferIfNecessary = function bufferIfNecessary(func, payload, parameters) {
  if (!payload) {
    // Ignore this event.
  } else if (!pulseTracker) {
    // Buffer this event until we have a `pulseTracker` instance *if* we are in a browser, discard
    // it if we are in a serverside environment.
    if (isBrowser()) {
      bufferedEvents.push([func, parameters]);
    }
  } else {
    callImmediately(func, parameters);
  }
};
var event = exports.event = function event(payload) {
  return bufferIfNecessary('track', payload, ['trackerEvent', payload]);
};
var engagement = exports.engagement = function engagement(payload) {
  if (!warnedAboutEngagementTypeOnce && payload.type) {
    // eslint-disable-next-line no-console
    console.warn('@blocket/tracking-pulse: A engagement event should not have a type key since the SDK will override it.');
    warnedAboutEngagementTypeOnce = true;
  }
  return bufferIfNecessary('track', payload, ['engagementEvent', payload]);
};
var pageView = exports.pageView = function pageView(payload) {
  return bufferIfNecessary('trackPageView', payload, [payload]);
};
var update = exports.update = function update(payload) {
  var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return bufferIfNecessary('update', payload, [payload, merge]);
};
var useEvent = exports.useEvent = function useEvent(payloadProvider, dependencies) {
  return (0, _react.useEffect)(function () {
    Promise.resolve(payloadProvider()).then(event);
  }, dependencies);
};
var useEngagement = exports.useEngagement = function useEngagement(payloadProvider, dependencies) {
  return (0, _react.useEffect)(function () {
    Promise.resolve(payloadProvider()).then(engagement);
  }, dependencies);
};
var usePageView = exports.usePageView = function usePageView(payloadProvider, dependencies) {
  return (0, _react.useEffect)(function () {
    Promise.resolve(payloadProvider()).then(pageView);
  }, dependencies);
};
var useUpdate = exports.useUpdate = function useUpdate(payloadProvider, merge, dependencies) {
  return (0, _react.useEffect)(function () {
    Promise.resolve(payloadProvider()).then(function (payload) {
      return update(payload, merge);
    });
  }, dependencies);
};
//# sourceMappingURL=tracker.js.map